import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import {PageWrapper} from 'components/PageWrapper';
import {InputText} from '../../blocks/inputs/InputText';
import {FileInput} from '../../blocks/inputs/FileInput';
import pdfIcon from 'images/pdfFile.svg';

@inject('resourcesStore')
@observer
class ResourceForm extends PureComponent {
  handleChange = e => {
    const {resourcesStore} = this.props;

    if (e.target.name === 'file') {
      resourcesStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      resourcesStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  render() {
    const {resourcesStore, submit} = this.props;
    const {resource, errors} = resourcesStore;
    const isNew = !resource.id;

    return (
      <PageWrapper>
        <form className="simple-form" onSubmit={submit}>
          <h2>{isNew ? 'Add OSCE' : 'Edit OSCE'}</h2>
          <InputText
            label='Add a Title'
            placeholder='Add a Title'
            fullWidth={true}
            onChange={this.handleChange}
            value={resource.title}
            name='title'
            errorText={errors ? errors.title : ''}
          />
          <FileInput
            label='Add a PDF'
            placeholder='Add a PDF'
            fullWidth={true}
            onChange={this.handleChange}
            value={resource.file}
            name='file'
            type='file'
            accept='.pdf'
            errorText={errors ? errors.file : ''}
          />
          {(!!resource.file_url && !resource.file.name) && (
            <a
              href={`https://pharmacistexamprep.ie${resource.file_url}`}
              target='_blank'
              style={{
                margin: '16px 0',
                alignSelf: 'flex-start'
              }}
            >
              <img src={pdfIcon} style={{width: '25px', height: '25px', marginRight: '16px'}} />PDF
            </a>
          )}
          {!!resource.file.name && (
            <a
              href={`https://pharmacistexamprep.ie${resource.file.name}`}
              target='_blank'
              style={{
                margin: '16px 0',
                alignSelf: 'flex-start'
              }}
            >
              <img src={pdfIcon} style={{width: '25px', height: '25px', marginRight: '16px'}} />{resource.file.name}
            </a>
          )}
          <div className="row">
            <button className="btn-new-main" type="submit">{isNew ? 'Create' : 'Edit'}</button>
            <Link to='/resources' className="btn-new-white margin-left-20">Cancel</Link>
          </div>
        </form>
      </PageWrapper>
    );
  }
}

export default ResourceForm;



// WEBPACK FOOTER //
// ./src/modules/resources/components/ResourceForm.js